import { jsx as t, jsxs as h } from "react/jsx-runtime";
import "react";
var r = (i) => /* @__PURE__ */ h("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...i,
  children: [
    /* @__PURE__ */ t("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ t("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-990 -68)",
      fill: "white"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H0V20H20V0Z",
      fill: "#496E2D"
    }),
    /* @__PURE__ */ t("path", {
      d: "M8.55078 15C11.3122 15 13.5508 12.7614 13.5508 10C13.5508 7.23858 11.3122 5 8.55078 5C5.78936 5 3.55078 7.23858 3.55078 10C3.55078 12.7614 5.78936 15 8.55078 15Z",
      fill: "#D80027"
    })
  ]
});
export {
  r as default
};
